import { useEffect, useState } from 'react';
import { Download, Share2 } from 'lucide-react';
import { Modal, useToast } from './ui';
import { lienPublic, APP_NAME } from '../lib/lieux';

// QR Code généré à la demande (la bibliothèque n'est chargée qu'à l'ouverture)
export default function QRModal({ lieu, onClose }) {
  const toast = useToast();
  const [dataUrl, setDataUrl] = useState(null);
  const url = lieu ? lienPublic(lieu.code_cau) : '';

  useEffect(() => {
    if (!lieu) { setDataUrl(null); return undefined; }
    let annule = false;
    import('qrcode').then(({ default: QRCode }) =>
      QRCode.toDataURL(url, { width: 600, margin: 2, color: { dark: '#10233F', light: '#FFFFFF' } })
    ).then(d => { if (!annule) setDataUrl(d); });
    return () => { annule = true; };
  }, [lieu, url]);

  const nomFichier = lieu ? `${lieu.code_cau}.png` : 'qr.png';

  const telecharger = () => {
    const a = document.createElement('a');
    a.href = dataUrl;
    a.download = nomFichier;
    a.click();
    toast('QR Code téléchargé');
  };

  const partagerQR = async () => {
    try {
      const blob = await (await fetch(dataUrl)).blob();
      const fichier = new File([blob], nomFichier, { type: 'image/png' });
      if (navigator.canShare && navigator.canShare({ files: [fichier] })) {
        await navigator.share({ files: [fichier], title: lieu.nom, text: `${lieu.nom} — ${lieu.code_cau}\n${url}` });
        return;
      }
      if (navigator.share) { await navigator.share({ title: lieu.nom, url }); return; }
      telecharger();
    } catch (e) {
      if (e && e.name !== 'AbortError') telecharger();
    }
  };

  return (
    <Modal open={!!lieu} onClose={onClose} titre="QR Code du lieu" etroite>
      {lieu && (
        <div className="qr">
          <p className="texte-secondaire">Scanner pour retrouver ce lieu</p>
          <div className="qr-image">
            {dataUrl ? <img src={dataUrl} alt={`QR Code ${lieu.code_cau}`} /> : <div className="sk qr-sk" />}
          </div>
          <div className="cau cau-moyen">{lieu.code_cau}</div>
          <p className="qr-nom">{lieu.nom}</p>
          <p className="qr-marque">{APP_NAME}</p>
          <div className="confirm-actions">
            <button className="btn btn-secondaire" onClick={partagerQR} disabled={!dataUrl}><Share2 size={18} /> Partager</button>
            <button className="btn btn-primaire" onClick={telecharger} disabled={!dataUrl}><Download size={18} /> Télécharger</button>
          </div>
        </div>
      )}
    </Modal>
  );
}
